<template>
  <z-page class="sales-split-manage">
    <!-- 搜索栏 -->
    <div class="page-search">
      <div class="search-item">
        <div>姓名：</div>
        <div>
          <el-input
            size="mini"
            class="long"
            v-model="search.text"
            placeholder="关键字搜索"
            suffix-icon="el-icon-search"
          ></el-input>
        </div>
      </div>
      <div @click="$func.shake(getdata,1)" class="search-btn z-btn normal">搜索</div>
      <div @click="clearsearch" style="margin-left:20px;" class="search-btn">清除搜索</div>
    </div>
    <!-- 列表 -->
    <div class="page-list">
      <div class="list-head">
        <div>产品名称</div>
        <div>产品套餐</div>
        <div>分成类型</div>
        <div>分成比例/金额</div>
        <div>操作</div>
      </div>
      <div v-loading="loading" class="list-main">
        <div style="text-align: center" class="list-item" v-if="data_list.length<=0">暂无数据</div>
        <div v-for="(item, index) in data_list" :key="index" class="list-item">
          <div>{{ item.productName }}</div>
          <div>{{ item.mealKeyName }}</div>
          <div>{{ item.saleDeptCostType|saleDeptCostType}}</div>
          <div>{{ item.saleDeptCostRate|fix}}{{(item.saleDeptCostType=='0'||item.saleDeptCostType=='2')?'%':(item.saleDeptCostType=='1'?'元':'')}}</div>
          <div>
            <span
              class="font-btn normal"
              @click="$store.state.userInfo.accountType=='1'?null:edit(item)"
              :class="{unclick:$store.state.userInfo.accountType=='1'}"
            >编辑</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 分页 -->
    <z-pagination
      @sizeChange="getdata()"
      @pageChange="handleCurrentChange"
      :current-page.sync="nowPage"
      :page-size="10"
      :total="total"
    ></z-pagination>

    <z-windowPop
      v-model="Flag"
      width="454px"
      height="254px"
      @confirm="$func.shake(popFunc)"
      :black="true"
      :btnshow="true"
      top="50%"
      title="分成设置"
    >
      <div class="popmain">
        <span>分成类型：</span>
        <el-select
          size="mini"
          v-model="nowdata.saleDeptCostType"
          @change="()=>{this.nowdata.saleDeptCostRate=''}"
          slot="prepend"
          placeholder="请选择"
        >
          <el-option label="销售额比例" value="0"></el-option>
          <el-option label="固定金额" value="1"></el-option>
          <el-option label="毛利润比例" value="2"></el-option>
        </el-select>
      </div>
      <div class="popmain">
        <span>{{nowdata.saleDeptCostType=='1'?'金额':'比例'}}：</span>
        <el-input
          size="mini"
          class="long"
          v-model="nowdata.saleDeptCostRate"
          :placeholder="nowdata.saleDeptCostType=='1'?'请输入金额':'请输入百分比'"
        ><template slot="append">{{nowdata.saleDeptCostType=='1'?'元':'%'}}</template></el-input>
      </div>
    </z-windowPop>
  </z-page>
</template>

<script>
export default {
  data() {
    return {
      Flag: false,
      loading: false,
      search: {},
      data_list: [],
      total: 0,
      nowPage: 1,
      nowdata: ""
    };
  },
  created() {
    console.log();

    this.getdata(1);
  },
  methods: {
    //编辑方法
    popFunc() {
      this.Flag=false
      let url = `/api/supplier/modify/royalty/config/${this.nowdata.id}`;
      this.$http.post(url, "", {
        params: {
          user_type: 2,
          cost_type: this.nowdata.saleDeptCostType,
          cost_rate: this.nowdata.saleDeptCostRate
        }
      })
      .then(res=>{
        if(res.code=='200'){
          this.successTip('修改成功！')
          this.getdata()
        }else{
          this.errorTip(res.message)
        }
      })
    },
    //编辑
    edit(val) {
      this.nowdata = JSON.parse(JSON.stringify(val));
      this.Flag = true;
    },
    //获取数据方法
    getdata(num) {
      this.nowPage=num||this.nowPage
      this.loading = true;
      let url = `/api/supplier/get/sale/royalty`;
      this.$http
        .get(url, {
          params: {
            page: num || this.nowPage, // 页码
            key_word: this.search.text || null //  产品名称
          }
        })
        .then(res => {
          if (res.code == "200") {
            this.data_list = res.res_data.list;
            this.total = res.res_data.total;
          } else {
            this.errorTip(res.res_data);
          }
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
        });
    },
    clearsearch() {
      this.search.text = "";
      this.getdata(1);
    },
    // 页面改变
    handleCurrentChange(val) {
      this.nowPage = val;
      this.getdata();
    }
  }
};
</script>

<style lang="less" scoped>
.sales-split-manage {
  .list-head,
  .list-item {
    > div {
      width: 20%;
      &:nth-child(5) {
        text-align: center;
      }
    }
  }
}
.popmain {
  position: relative;
  margin: 16px 24px 16px 32px;
  span {
    display: inline-block;
    width: 70px;
    text-align: right;
  }
  /deep/.el-select,
  .el-input {
    width: calc(~"100% - 70px");
  }
  & + .popmain {
    margin: 0px 24px 32px 32px;
  }
}
</style>